import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const catalogCoveragePlugin = createPlugin({
  id: 'catalog-coverage',
  routes: { root: rootRouteRef },
});

export const CatalogCoveragePage = catalogCoveragePlugin.provide(
  createRoutableExtension({
    name: 'CatalogCoveragePage',
    component: () =>
      import('./components/CatalogCoveragePage').then(
        m => m.CatalogCoveragePage,
      ),
    mountPoint: rootRouteRef,
  }),
);
